import Ajax from "@/api/ajax";
export default{
    // 区号列表
    smsMsg(params) {
        return Ajax.post("/Home/smsMsg", params);
    },

}